// sherpa-onnx voice configuration for Phase 2a voice commands.
//
// On-device, offline, keyless (Apache-2.0). No AccessKey, no cloud, no per-use
// cost. Model files ship inside the Android app assets/ — see
// android/app/src/main/assets/sherpa_models/README.md for how to obtain them.
//
// Each model directory (relative to android assets/) must contain:
//   encoder.onnx, decoder.onnx, joiner.onnx, tokens.txt
// The KWS (wake-word) directory additionally contains keywords.txt.
//
// These paths are passed through to the native Voice plugin at runtime.

export const KWS_MODEL_DIR = "sherpa_models/kws"; // wake word ("Hey Niner")
export const ASR_MODEL_DIR = "sherpa_models/asr"; // streaming commands + dictation
